// src/components/DataHistory.jsx
import React, { useState } from "react";

const DataHistory = () => {
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [dataType, setDataType] = useState("all");

  // --- Your channel ID & API Key ---
  const channelID = "3018449";
  const readAPIKey = "WPIXJNON8E0WC5U0";

  // ✅ Convert SL local date/time directly to UTC ISO string
  const toUTCString = (dateStr, timeStr) => {
    const localDate = new Date(`${dateStr}T${timeStr}:00`);
    return localDate.toISOString(); // correct: system already in SL time
  };

  // ✅ Display UTC timestamp as SL local time
  const toSriLankaTime = (utcString) => {
    const utcDate = new Date(utcString);
    return utcDate.toLocaleString("en-LK", { timeZone: "Asia/Colombo" });
  };

  const fetchFilteredData = async () => {
    if (!startDate || !endDate) {
      setError("Please select both start and end dates.");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const startUTC = toUTCString(startDate, startTime);
      const endUTC = toUTCString(endDate, endTime);

      const url = `https://api.thingspeak.com/channels/${channelID}/feeds.json?api_key=${readAPIKey}&start=${startUTC}&end=${endUTC}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.feeds && data.feeds.length > 0) {
        let filteredFeeds = data.feeds;

        if (dataType === "temperature") {
          filteredFeeds = filteredFeeds.map((f) => ({
            ...f,
            field2: null,
            field3: null,
          }));
        } else if (dataType === "humidity") {
          filteredFeeds = filteredFeeds.map((f) => ({
            ...f,
            field1: null,
            field3: null,
          }));
        } else if (dataType === "voc") {
          filteredFeeds = filteredFeeds.map((f) => ({
            ...f,
            field1: null,
            field2: null,
          }));
        }

        setFeeds(filteredFeeds);
      } else {
        setFeeds([]);
        setError("No data available for the selected range.");
      }
    } catch (err) {
      setError("Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="data-history-container">
      <h2 style={{ color: "white", textAlign: "center" }}>Data History</h2>

      {/* Filter Section */}
      <div className="filter-container">
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
        <label>
          Start Time:
          <input
            type="time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
        </label>
        <label>
          End Time:
          <input
            type="time"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
          />
        </label>
        <label>
          Data Type:
          <select
            value={dataType}
            onChange={(e) => setDataType(e.target.value)}
          >
            <option value="all">Temperature, Humidity & VOC</option>
            <option value="temperature">Temperature Only</option>
            <option value="humidity">Humidity Only</option>
            <option value="voc">VOC Only</option>
          </select>
        </label>
        <button onClick={fetchFilteredData} className="filter_btn">
          Filter
        </button>
      </div>

      {/* Messages */}
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      {feeds.length > 0 && (
        <div className="scroll-container">
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Date & Time (SL)</th>
                  {(dataType === "all" || dataType === "temperature") && (
                    <th>Temperature (°C)</th>
                  )}
                  {(dataType === "all" || dataType === "humidity") && (
                    <th>Humidity (%)</th>
                  )}
                  {(dataType === "all" || dataType === "voc") && (
                    <th>VOC (ppm)</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {feeds.map((feed) => (
                  <tr key={feed.entry_id}>
                    <td data-label="Date & Time (SL)">
                      {toSriLankaTime(feed.created_at)}
                    </td>
                    {(dataType === "all" || dataType === "temperature") && (
                      <td data-label="Temperature (°C)">{feed.field1}</td>
                    )}
                    {(dataType === "all" || dataType === "humidity") && (
                      <td data-label="Humidity (%)">{feed.field2}</td>
                    )}
                    {(dataType === "all" || dataType === "voc") && (
                      <td data-label="VOC (ppm)">{feed.field3}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataHistory;
